var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#4D70B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3205 7.70834H7.74952V10.257C7.74952 10.6673 7.41395 11 7 11C6.58605 11 6.25048 10.6673 6.25048 10.257V7.70834H3.67955C3.29342 7.6687 3 7.34614 3 6.96132C3 6.5765 3.29342 6.25394 3.67955 6.21431H6.24242V3.67365C6.28241 3.29088 6.60778 3 6.99597 3C7.38416 3 7.70954 3.29088 7.74952 3.67365V6.21431H10.3205C10.7066 6.25394 11 6.5765 11 6.96132C11 7.34614 10.7066 7.6687 10.3205 7.70834V7.70834Z",
    fill: "#4D70B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ba6c734630030b2a424f846a281298f6.svg";
export { ForwardRef as ReactComponent };